module.exports = __webpack_public_path__ + "media/images/lb/969-c88e67501237ba5168879956ac0b0122.svg";